import { createApp } from 'vue'
import registerComponents from './main-components.js'
import App from './App.vue'
import router from '@/router.js'
import http from '@/lib/http'
import eventbus from '@/eventbus.js'
import { isLoggedIn, redirectToLogin, handleAuthenticationFailure } from '@/lib/authentication.js'
import ActionCableVue from 'actioncable-vue'
import ObserverDirective from '@/lib/directives/observer-directive.js'
import AttrChangeDirective from '@/lib/directives/attribute-change.js'
import formatters from '@/lib/format.js'
import settings from '@/lib/settings'
import duration from '@/lib/duration'
import { getTimingApiBaseUrl, getTimingWebsocketUrl } from '@/lib/service-urls.js'

import sharedStore from '@/shared-store.js'

const actionCableVueOptions = {
  debug: true,
  debugLevel: 'error',
  connectionUrl: getTimingWebsocketUrl(),
  connectImmediately: true,
}

const app = createApp(App)
  .use(sharedStore)
  .use(router)
  .use(http, {
    baseURL: (() => getTimingApiBaseUrl())(),
    checkLogin: {
      with: () => router.currentRoute?.value?.name === 'login' || isLoggedIn(),
      handler() { redirectToLogin() },
    },
    authenticationFailure() { handleAuthenticationFailure() },
    csrfHeader: true,
    headers: {
      Accept: 'application/json',
    },
    authorization: () => (settings.token ? `Bearer ${settings.token}` : ''),
  })
  .use(ActionCableVue, actionCableVueOptions)
  .use(ObserverDirective)
  .use(AttrChangeDirective)
  .use(duration)

app.config.globalProperties.$fmt = { ...formatters }
app.config.globalProperties.settings = settings
app.config.globalProperties.closeIfInPopover = function closeIfInPopover() {
  let p = this.$parent
  while (p) {
    if (p.isPopover) {
      p.hide()
      break
    }
    p = p.$parent
  }
}

app.config.globalProperties.sharedStore.loadRaceEvents({
  requestingSlug: settings.activeRaceEventSlug,
}).then(() => {
  const routeRaceEventId = router.currentRoute.value?.params?.raceEventId
  const initialRaceEventId = routeRaceEventId ? null : settings.activeRaceEventId

  if (initialRaceEventId) {
    app.config.globalProperties.sharedStore.setActiveRaceEvent(initialRaceEventId)
  }
})

registerComponents(app)
app.mount('#app')

setInterval(() => {
  eventbus.emit('tick', new Date())
}, 1000)
